import { Themed } from "@components/atoms/Themed"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("page", (props) => {
  return (
    <Themed page theme={props.page?.pageTheme} footer footerTheme={props.page?.footerTheme} className="w-full">
      <ContentBlocks blocks={props.page?.contentBlocks} />
    </Themed>
  )
})
